import * as THREE from 'three';
import EventBus from './EventBus.js';

/**
 * 渲染器管理器（单例）
 */
export class RendererManager {

    static #renderer = null;

    static init() {
        // 创建 WebGL 渲染器，并开启抗锯齿
        this.#renderer = new THREE.WebGLRenderer({ 
            antialias: true,
            powerPreference: "high-performance" // 提示浏览器优先考虑性能
        });

        // 设置像素比，防止在高清屏幕上模糊
        this.#renderer.setPixelRatio(window.devicePixelRatio);

        // 设置默认颜色空间
        this.#renderer.outputColorSpace = THREE.SRGBColorSpace;
        this.#renderer.toneMapping = THREE.ACESFilmicToneMapping;
        this.#renderer.toneMappingExposure = 1.0;

        // 向事件总线注册 resize 事件，自动调整渲染尺寸
        EventBus.on('resize', () => {
            this.#renderer.setSize(window.innerWidth, window.innerHeight);
        });
        
        // 初始尺寸设置
        EventBus.emit('resize');
    }

    /**
     * 获取渲染器实例
     * @returns {THREE.WebGLRenderer}
     */
    static genRenderer() {
        if(!this.#renderer){
            this.init();
        }
        return this.#renderer;
    }
    
    /**
     * 清理资源
     */
    static dispose() {
        if (this.#renderer) {
            // 移除 resize 事件监听
            EventBus.off('resize');
            // 释放 WebGL 资源（关键：避免内存泄漏）
            this.#renderer.dispose();
            // 清空实例（支持后续重新初始化，可选）
            this.#renderer = null;
        }
    }
}